import { render } from "./AppMenuWorkspaceSelectOption.vue?vue&type=template&id=65ba9e28&scoped=true"
import script from "./AppMenuWorkspaceSelectOption.vue?vue&type=script&lang=js"
export * from "./AppMenuWorkspaceSelectOption.vue?vue&type=script&lang=js"

import "./AppMenuWorkspaceSelectOption.vue?vue&type=style&index=0&id=65ba9e28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ba9e28"]])

export default __exports__